import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import {
  selectSubscriptionCoupon,
  selectSubscriptionCampaignPrice,
  setSubscriptionCoupon,
  subscriptionCouponExpires,
  setSubscriptionCampaignPrice,
  subscriptionCampaignPriceExpires,
} from '~/redux/slices/subscription.slice'
import useSubscriptionIsRequired from '~/subscription/hooks/useSubscriptionIsRequired'

function useSubscriptionCouponAndPrice(): void {
  const router = useRouter()
  const couponId = router.query.coupon as string | undefined
  const priceId = router.query.price as string | undefined
  const couponCode = useAppSelector(selectSubscriptionCoupon)

  const campaignPrice = useAppSelector(selectSubscriptionCampaignPrice)
  const couponExpires = useAppSelector(subscriptionCouponExpires)
  const campaignPriceExpires = useAppSelector(subscriptionCampaignPriceExpires)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (couponId !== couponCode) {
      if (couponId) {
        dispatch(setSubscriptionCoupon(couponId))
      } else if (couponCode && couponExpires && new Date(couponExpires) < new Date()) {
        dispatch(setSubscriptionCoupon(undefined))
      }
    }

    if (priceId !== campaignPrice) {
      if (priceId) {
        dispatch(setSubscriptionCampaignPrice(priceId))
      } else if (campaignPrice && campaignPriceExpires && new Date(campaignPriceExpires) < new Date()) {
        dispatch(setSubscriptionCampaignPrice(undefined))
      }
    }
  }, [couponId, couponCode, priceId, campaignPrice, couponExpires, campaignPriceExpires, dispatch])
}

export default function useSubscription(): void {
  useSubscriptionCouponAndPrice()
  useSubscriptionIsRequired()
}
